var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5712 42.1476C54.8275 42.6539 54.7353 43.2669 54.3414 43.6754C53.9475 44.0839 53.3382 44.1983 52.8229 43.9605L46.158 40.8844C40.5564 38.2991 34.4435 37.1164 28.3411 37.3946C28.2686 39.3542 28.1611 41.3128 28.0184 43.2696L27.8359 45.7735C27.7252 47.2925 26.0314 48.1417 24.7479 47.3216C19.1773 43.7621 14.3345 39.1756 10.4776 33.8065L9.25044 32.0982C8.91652 31.6333 8.91652 31.0072 9.25044 30.5424L10.4776 28.8341C14.3345 23.465 19.1773 18.8784 24.7479 15.3189C26.0314 14.4988 27.7252 15.348 27.8359 16.867L28.0184 19.3709C28.1409 21.0506 28.2375 22.7316 28.3082 24.4134H30.0231C39.5724 24.4134 48.3103 29.7832 52.6242 38.3025L54.5712 42.1476Z",
    fill: "#2980B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.56483c070dcca48aec272436684aa68f.svg";
export { ForwardRef as ReactComponent };